let API_HOST = process.env.REACT_APP_API_HOST || "https://demo-api.inorain.tv";


window._HOST_ = API_HOST

const ROUTES = {

    check_email_req: API_HOST + "/user/auth/check_email",
    sing_in: API_HOST + "/user/login",
    verify_code: API_HOST + "/user/auth/verify_code",
    get_configs: API_HOST + "/application/get",
    sub_users: API_HOST + '/user/subUser/get',
    create_sub_user: API_HOST + "/user/subUser/addUser",
    verify_root: API_HOST + "/user/subUser/login",
    get_highlighted: API_HOST + "/application/vod/movie/highlighted",
    get_home: API_HOST + "/user/home",
    search: API_HOST + "/user/smart/search",
    get_channels: API_HOST + '/user/channels/getChannel',
    get_categories: API_HOST + '/user/channels/getCategory',
    get_lessons: API_HOST + '/application/vod/movies/lessons',
    get_movies: API_HOST + '/application/vod/movies',
    get_series: API_HOST + '/application/vod/series',
    get_favourites: API_HOST + '/user/favorites',
    // get_movie_info: API_HOST + '/application/vod/movie/info', // old request for movie info
    get_movie_info: API_HOST + '/application/vod/movie/v2/info', // new request for movie info
    get_movie_url: API_HOST + '/application/vod/movie/url',
    get_related_movies: API_HOST + '/application/vod/movie/related',
    get_day_epg: API_HOST + '/user/epg/getByDate',
    add_channel_to_favourites: API_HOST + "/user/channels/addFavorite",
    remove_channel_from_favourites: API_HOST + "/user/channels/deleteFavorite",
    add_movie_to_favourites: API_HOST + "/application/vod/movie/addFavorite",
    remove_movie_from_favourites: API_HOST + "/application/vod/movie/removeFavorite",
    remember_time: API_HOST + "/application/vod/movie/rememberTime",
    register_user: API_HOST + "/user/auth/register",
    getByRootUserId: API_HOST + "/user/subUser/getByRootUserId",
    getLanguage: API_HOST + "/application/app_languages",
    get_sub_images: API_HOST + "/application/profile_icons",
    get_user_by_id: API_HOST + "/user/subUser/getById",
    edit_profile: API_HOST + "/user/subUser/update/tvmivi",
    translated_words: API_HOST + '/application/translations',
    set_online: API_HOST + '/user/setOnline',
    validate_token: API_HOST + "/user/validateToken",
    set_view_channels: API_HOST + "/user/channels/set_view",
    get_tariff: API_HOST + "/user/getTariff",
    get_pricing_items: API_HOST + "/user/tariffs/get",
    remove_watch_list: API_HOST + "/application/vod/watched_movie",
    subscribe: API_HOST + "/payment/authorize/subscription",
    get_payments: API_HOST + "/payment/methods",
    get_payment_history: API_HOST + "/payment/history",
    authorize: API_HOST + "/payment/authorize/one_time_payment",
    get_stripe: API_HOST + "/payment/stripe/checkout",
    forgot_password: API_HOST + "/user/auth/reset_password",
    change_password: API_HOST + "/user/auth/confirm_password",
    resend_verify_email: API_HOST + "/user/resend_verify_email",
    rent_movie: API_HOST + "/application/vod/merchant/rent",
    buy_movie: API_HOST + "/application/vod/merchant/buy",
    get_app_url: API_HOST + "/application/mobil_app_url",
    get_question: API_HOST + "/user/question",
    get_question_answers: API_HOST + "/user/question/answer",
    get_messages: API_HOST + "/user/chat/message",
    get_not_read_messages_count: API_HOST + "/user/chat/not_read_count",
    login_guest_mode: API_HOST + '/user/auth/login_guest',

    set_advertisement: (type) => {
        return API_HOST + "/user/advertisement/view/" + type
    },

    send_message: function (type) {
        return API_HOST + "/user/chat/send/" + type
    }

}

export default ROUTES
